import Vue from 'vue';
import Test from '@/components/pages/TestPage/Test.vue'

Vue.component('test', Test);
